var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, isValidElement, useRef, } from 'react';
import classNames from 'clsx';
import GridAside from './GridAside';
import GridGroup from './GridGroup';
import GridItem, {} from './GridItem';
import GridTitle from './GridTitle';
import useMasonryLayout from './hooks/useMasonryLayout';
import useNumberOfTrailingChildren from './hooks/useNumberOfTrailingChildren';
import { GridContainer } from './styles/grid.styled';
const getChildGridElementType = (child) => isValidElement(child) &&
    typeof child.type !== 'string' &&
    child.type.GRID_ELEMENT;
const Grid = (_a) => {
    var { children, class: className, constrainedWidth, equalHeight, justify = 'start', columns = 1, useMasonry, tagName } = _a, attributes = __rest(_a, ["children", "class", "constrainedWidth", "equalHeight", "justify", "columns", "useMasonry", "tagName"]);
    const gridRef = useRef();
    useMasonryLayout({ useMasonry, gridRef });
    const gridClassNames = classNames('PONCHO-grid', className);
    const childrenWithItems = Children.map(children, (child) => {
        if (typeof getChildGridElementType(child) === 'undefined')
            return _jsx(Grid.Item, { children: child });
        return child;
    });
    const childrenArray = Children.toArray(childrenWithItems);
    const asideChildIndex = [...childrenArray].findIndex((child) => getChildGridElementType(child) === 'GRID_ASIDE');
    const gridItems = [...childrenArray].filter((child) => getChildGridElementType(child) === 'GRID_ITEM');
    const gridTitle = [...childrenArray].filter((child) => getChildGridElementType(child) === 'GRID_TITLE');
    const gridGroup = [...childrenArray].filter((child) => getChildGridElementType(child) === 'GRID_GROUP');
    const numberOfTrailingChildren = useNumberOfTrailingChildren(useMasonry
        ? 0
        : gridItems.filter((gridItem) => !(isValidElement(gridItem) && gridItem.props.fullWidth)).length, columns);
    const trailingChildren = gridItems.slice(gridItems.length - numberOfTrailingChildren, gridItems.length);
    const hasAsideChild = asideChildIndex > -1;
    const asidePosition = asideChildIndex === 0 ? 'left' : 'right';
    const renderContent = () => {
        const gridItemsToRender = numberOfTrailingChildren
            ? gridItems.filter((_, index) => index < gridItems.length - numberOfTrailingChildren)
            : gridItems;
        return (_jsxs(_Fragment, { children: [gridTitle, gridItemsToRender, gridGroup, !!trailingChildren.length && (_jsx(Grid.Item, { fullWidth: true, children: _jsx(GridContainer, { "$columns": columns, "data-grid-container": true, children: _jsx(GridContainer, { "$columns": columns, "$justify": justify, "$numberOfTrailingChildren": numberOfTrailingChildren, "data-grid-container": true, children: trailingChildren }) }) }))] }));
    };
    return (_jsx(GridContainer, Object.assign({ as: tagName, ref: gridRef, className: gridClassNames, "$constrainedWidth": constrainedWidth, "$equalHeight": equalHeight, "$useMasonry": useMasonry, "$columns": columns, "$hasAside": hasAsideChild, "$asidePosition": asidePosition, "data-grid-container": true }, attributes, { children: hasAsideChild ? (_jsxs(_Fragment, { children: [asidePosition === 'left' && childrenArray[asideChildIndex], _jsx(GridContainer, { "$columns": columns, children: renderContent() }), asidePosition === 'right' && childrenArray[asideChildIndex]] })) : (renderContent()) })));
};
Grid.Group = GridGroup;
Grid.Item = GridItem;
Grid.Aside = GridAside;
Grid.Title = GridTitle;
export default Grid;
